
import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { config } from './config';
import { ToastController, LoadingController } from '@ionic/angular';
import { Injectable } from '@angular/core';
// import { Storage } from '@ionic/storage';

@Injectable({
    providedIn: 'root'
  })

export class UtilitiesFunctions{
    constructor(
      public alertController: AlertController
      , private toastCtrl: ToastController
      , public http: HttpClient
      , public loadingCtrl: LoadingController
      // , private storage: Storage
      ) {}

    validate_email(email) 
    {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
      {
        return (true);
      } else {
        return (false);
      }
    }

    add_days(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }

    format_date(date){
      return date.toISOString().split('T')[0]
    }

    get_datetime_now(){
      let date_now = new Date()
      return date_now;
    }
  
    async toast_alert(message, duration, position) {
      const toast = await this.toastCtrl.create({
        message: message,
        duration: duration,
        position: position
      });

      toast.present();
    }

    async alert_prompt(header, message, true_label, false_label) {
        var response;
        const alert = await this.alertController.create({
          header: header,
          message: message,
          buttons: [{text: true_label, handler: () => {alert.dismiss(true)
            return false}}, {text: false_label, handler: () => {alert.dismiss(false);
              return false;}}],
        });
    
        await alert.present();

        await alert.onDidDismiss().then((data)=>{
          response = data
        });
        return response["data"];
    }

  string_replace(string, search_value, replace_value) {
    if(string !== undefined && string !== null) {
      if(string.indexOf(search_value) !== -1){
        var re = new RegExp(search_value, 'g');
        return string.replace(re, replace_value);
      } else {
        return string;
      }
    } else {
      return string;
    }
  }
}